import {GlobalState} from "../types/global.ts";
import {APP_LOCAL_STORAGE} from "../utils/constants.ts";
import {createSlice} from "@reduxjs/toolkit";

const LS_KEY_REFERRER_ROUTE = "referrerRoute";

const initialState: GlobalState = {
    referrerRoute: localStorage.getItem(`${APP_LOCAL_STORAGE}/${LS_KEY_REFERRER_ROUTE}`) || undefined,
};

export const globalSlice = createSlice({
    name: "globalSlice",
    initialState,
    reducers: {
        setReferrerRoute: (state, action: { payload: string }) => {
            localStorage.setItem(`${APP_LOCAL_STORAGE}/${LS_KEY_REFERRER_ROUTE}`, action.payload);
            state.referrerRoute = action.payload;
        },
        clearReferrerRoute: (state) => {
            localStorage.removeItem(`${APP_LOCAL_STORAGE}/${LS_KEY_REFERRER_ROUTE}`);
            state.referrerRoute = undefined;
        }
    }
});

export const globalReducer = globalSlice.reducer;
export const {setReferrerRoute, clearReferrerRoute} = globalSlice.actions;